import { AiPopupState } from "../../types";
import { TextSelection } from "prosemirror-state";
export const createReplaceInputAction = (deps) => {
    const { command, setValue, inputElement } = deps;
    return function replaceInputAction() {
        const inputPrompt = command.prompt.replaceAll("{{input}}", "");
        setValue(inputPrompt);
        inputElement.focus();
        inputElement.setSelectionRange(inputPrompt.length - 1, inputPrompt.length - 1);
    };
};
export const createPromptAction = (deps) => {
    const { command, inputValue, option, getCommandInput, handlePrompt } = deps;
    return function promptAction() {
        var _a;
        const input = getCommandInput();
        const fullPrompt = command.prompt
            .replaceAll("{{input}}", input)
            .replaceAll("{{prompt}}", inputValue)
            .replaceAll("{{option}}", (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : "");
        handlePrompt(fullPrompt);
    };
};
export const createClosePopupAction = (deps) => {
    const { view, handleClosePopup } = deps;
    return function closePopupAction() {
        view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, view.state.selection.to)));
        handleClosePopup();
    };
};
export const createReplaceSelectionAction = (deps) => {
    const { view, currentResult, handleClosePopup } = deps;
    return function replaceSelectionAction() {
        if (!currentResult)
            return;
        const { from, to } = view.state.selection;
        const tr = view.state.tr.replaceWith(from, to, currentResult.fragment);
        tr.setSelection(TextSelection.create(tr.doc, from, from + currentResult.fragment.size));
        view.dispatch(tr);
        handleClosePopup();
    };
};
export const createAppendSelectionAction = (deps) => {
    const { view, currentResult, handleClosePopup } = deps;
    return function appendSelectionAction() {
        if (!currentResult)
            return;
        const { to } = view.state.selection;
        const tr = view.state.tr.insert(to, currentResult.fragment);
        tr.setSelection(TextSelection.create(tr.doc, to, to + currentResult.fragment.size));
        view.dispatch(tr);
        handleClosePopup();
    };
};
export const createDiscardChangesAction = (deps) => {
    const { view, handleClosePopup, popupState } = deps;
    return function discardChangesAction() {
        if (popupState === AiPopupState.ContentGenerated) {
            handleClosePopup();
        }
        if (popupState === AiPopupState.InlineContentGenerated) {
            const { from, to } = view.state.selection;
            const tr = view.state.tr.delete(from, to);
            tr.setSelection(TextSelection.create(tr.doc, from));
            view.dispatch(tr);
            handleClosePopup();
        }
    };
};
